import { useRoute } from "@/lib/router";
import { HomePage } from "@/pages/HomePage";
import { StudyPage } from "@/pages/StudyPage";
import { ElLaGame } from "@/games/ElLaGame";
import { VocabGame } from "@/games/VocabGame";
import { ConjGame } from "@/games/ConjGame";
import { RelayPage } from "@/pages/RelayPage";
import { AuthGate } from "@/components/AuthGate";
import { SyncManager } from "@/components/SyncManager";

export default function App() {
  return (
    <AuthGate>
      <SyncManager />
      <RoutedApp />
    </AuthGate>
  );
}

function RoutedApp() {
  const route = useRoute();

  if (route.name === "home") return <HomePage />;
  if (route.name === "study") return <StudyPage />;
  if (route.name === "relay") return <RelayPage />;

  if (route.name === "play") {
    if (route.game === "el_la") return <ElLaGame />;
    if (route.game === "conj") return <ConjGame />;
    if (route.game === "vocab") return <VocabGame />;
  }

  // results screen is rendered inside the game shell when session.done
  if (route.name === "results") {
    if (route.game === "el_la") return <ElLaGame />;
    if (route.game === "conj") return <ConjGame />;
    if (route.game === "vocab") return <VocabGame />;
  }

  return <HomePage />;
}
